







import TransactionsView from '@/components/TransactionsView.vue'
import { AgencyFundTransactionsType } from '@/api/Agency/agency.interface'
import Vue from 'vue'
import { agencyFundTransactionsController } from '@/api/Agency/agency.api'
export default Vue.extend({
  components: {
    TransactionsView,
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      types: this.$utils.makeSelectable(AgencyFundTransactionsType),
      controller: agencyFundTransactionsController,
    }
  },
})
